/**
 * A MUI X dátumválasztók MAGYAR feliratai — EGY helyen. [Web UX 9 / T2, 2026-10-13]
 *
 * MI VOLT A BAJ (lelet: `App.tsx:26` és a 12 belső `<LocalizationProvider>`): a providerek csak az
 * `adapterLocale`-t (vagy azt sem) kapták meg. Az `adapterLocale` a DÁTUM-FORMÁTUMOT és a hónap-/napneveket
 * magyarítja, a picker SAJÁT feliratait (`localeText`) NEM — azok a MUI X alapértelmezése szerint ANGOLOK
 * maradtak: „Cancel" / „OK" / „Clear" / „Today" gomb, „Select date" fejléc (telefonos nézet), a
 * hónapválasztó mezőjének „MMMM YYYY" helykitöltője, és az olvasó-szoftvernek szóló „Choose date",
 * „Previous month", „Next month" feliratok.
 *
 * A JAVÍTÁS: a MUI X saját magyar fordítása (`huHU`, a telepített 8.11.2-ben megvan), két apró
 * kiegészítéssel:
 *   - a felület TEGEZ („Ellenőrizd…", „Válassz…"), a `huHU` viszont magáz („Válasszon dátumot") — a
 *     látható/felolvasott mondatokat tegezőre írjuk;
 *   - a `huHU`-ból hiányzó két kulcs (csak a Pro időszak-választóé, ma nem használjuk) is magyar legyen,
 *     hogy egy jövőbeli bevezetésnél se szivárogjon be angol szöveg.
 *
 * HASZNÁLAT: MINDEN `<LocalizationProvider>` megkapja `localeText={HU_PICKER_LOCALE_TEXT}`-ként. A belső
 * provider a MUI X-ben ugyan ÖRÖKLI a külső `localeText`-jét (`LocalizationProvider.js`: a szülő és a saját
 * összefésülése), de a komponensek a teszteken (és bármely jövőbeli, `App`-on kívüli beágyazásban) a külső
 * nélkül futnak — ezért kifejezetten mindegyik kapja. Forrás-őr: `utils/__tests__/hungarianLeftovers.guard.test.ts`.
 *
 * ⚠️ A mező FORMÁTUMÁT ez NEM változtatja: azt az adapter és a hívó `format`-ja adja, a `localeText` csak
 * feliratokat hordoz.
 */
import { huHU } from '@mui/x-date-pickers/locales';
import type { PickersInputLocaleText } from '@mui/x-date-pickers/locales';
// A dayjs magyar nyelvi csomagja: az `adapterLocale="hu"` csak akkor hat, ha a csomag BE VAN töltve
// (különben a dayjs csendben angolra esik vissza). Az `App.tsx` is betölti — itt azért, hogy a
// konstanst használó komponens önmagában (tesztben) is magyar legyen.
import 'dayjs/locale/hu';

const huHUBase: PickersInputLocaleText = huHU.components.MuiLocalizationProvider.defaultProps.localeText;

export const HU_PICKER_LOCALE_TEXT: PickersInputLocaleText = {
  ...huHUBase,
  // tegező változat (a `huHU` magáz)
  openDatePickerDialogue: (formattedDate) =>
    formattedDate ? `Válassz dátumot, a kiválasztott dátum: ${formattedDate}` : 'Válassz dátumot',
  openTimePickerDialogue: (formattedTime) =>
    formattedTime ? `Válassz időt, a kiválasztott idő: ${formattedTime}` : 'Válassz időt',
  calendarViewSwitchingButtonAriaLabel: (view) =>
    view === 'year'
      ? 'az évválasztó nyitva, válts a naptárnézetre'
      : 'a naptárnézet nyitva, válts az évválasztóra',
  timeTableLabel: 'válassz időt',
  dateTableLabel: 'válassz dátumot',
  // a `huHU`-ból hiányzó két kulcs (Pro időszak-választó)
  timeRangePickerToolbarTitle: 'Időszak kiválasztása',
  openRangePickerDialogue: (formattedRange) =>
    formattedRange ? `Válassz időszakot, a kiválasztott időszak: ${formattedRange}` : 'Válassz időszakot',
};
